import { render, staticRenderFns } from "./ProductCrossSell.vue?vue&type=template&id=0d5b89e2&"
import script from "./ProductCrossSell.vue?vue&type=script&lang=js&"
export * from "./ProductCrossSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5b89e2')) {
      api.createRecord('0d5b89e2', component.options)
    } else {
      api.reload('0d5b89e2', component.options)
    }
    module.hot.accept("./ProductCrossSell.vue?vue&type=template&id=0d5b89e2&", function () {
      api.rerender('0d5b89e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/ProductCrossSell.vue"
export default component.exports